// module imports
import Link from 'next/link';

// file imports
import { DataTable, EventActions } from '@/components';
import { formatDate } from '@/lib/helpers';
import { IEvent } from '@/types';

interface EventsTableProps {
  events: IEvent[];
  openDropdown: string | null;
  setOpenDropdown: (id: string | null) => void;
}

export default function EventsTable({ events, openDropdown, setOpenDropdown }: EventsTableProps) {
  const columns = [
    {
      key: 'startDate',
      label: 'Start Date',
      render: (event: IEvent) => formatDate(event.startDate.toString()),
    },
    {
      key: 'endDate',
      label: 'End Date',
      render: (event: IEvent) => formatDate(event.endDate.toString()),
    },
    {
      key: 'title',
      label: 'Name of Event',
      render: (event: IEvent) => (
        <div>
          <Link href={`/events/${event.slug}`} className="font-medium text-blue-600 hover:underline">
            {event.title}
          </Link>
        </div>
      ),
    },
    { key: 'venue', label: 'Venue' },
    { key: 'numberOfSpeakers', label: 'No. Speakers' },
    { key: 'responses', label: 'Responses' },
    { key: 'leads', label: 'Leads' },
    {
      key: 'actions',
      label: 'Actions',
      render: (event: IEvent) => <EventActions eventSlug={event.slug || event._id || ''} isOpen={openDropdown === (event.slug || event._id)} onToggle={() => setOpenDropdown(openDropdown === (event.slug || event._id) ? null : event.slug || event._id || null)} responses={event.responses} />,
    },
  ];

  return <DataTable<IEvent> data={events} columns={columns} emptyMessage="No events found. Create your first event to get started!" />;
}
